// import React, { useState, useEffect } from 'react'; // Import useState and useEffect
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Home from './components/Home';
// import Navbar from './components/Navbar';
// import "./App.css";
// // import 'react-toastify/dist/ReactToastify.css';
// import { onAuthStateChanged } from "firebase/auth"; // Import onAuthStateChanged
// import { auth } from './components/firebase'; // Import auth from firebase.js (assuming firebase.js is in the same directory)
// import Login from './components/Login';
// import UploadEvent from './components/UploadEvent';
// import EventDetail from './components/EventDetail'; // Import EventDetail component
// import Footer from './components/Footer';


// const App = () => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setIsLoggedIn(true);
//       } else {
//         setIsLoggedIn(false);
//       }
//     });

//     return () => unsubscribe();
//   }, []);

//   return (
//     <>
//       <Router>
//         <Navbar isLoggedIn={isLoggedIn} />
//         <div>
//           <Routes>
//             {/* Public Routes */}
//             <Route exact path="/login" element={<Login />} />
//             <Route exact path="/home" element={<Home />} />
//             <Route exact path="/" element={<Home />} />
//             <Route path="/event/:id" element={<EventDetail />} /> {/* Event Detail Route */}
            
//             {/* Protected Routes */}
//             {isLoggedIn && (
//               <>
//                 <Route exact path="/UploadEvent" element={<UploadEvent />} /> {/* Upload Event Route */}
//               </>
//             )}
  
//             {/* Add more routes here */}
//           </Routes>
//         </div>
//         <Footer /> {/* Footer component added here */}
//       </Router>
//     </>
//   );
  
// }

// export default App;


// import React, { useState, useEffect } from 'react'; 
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Removed useNavigate from import
// import Home from './components/Home';
// import Navbar from './components/Navbar';
// import "./App.css";
// import { onAuthStateChanged } from "firebase/auth"; 
// import { auth } from './components/firebase'; 
// import Login from './components/Login';
// import UploadEvent from './components/UploadEvent';
// import EventDetail from './components/EventDetail'; 
// import Footer from './components/Footer';
// import AttendanceForm from './components/AttendanceForm';
// const App = () => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [isAdmin, setIsAdmin] = useState(false); // State to check if the user is an admin

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (user) => {
//       if (user) {
//         setIsLoggedIn(true);

//         // Retrieve JWT token from session storage
//         const jwtToken = sessionStorage.getItem('jwtToken');
//         console.log('JWT Token retrieved:', jwtToken); // Check if JWT token is retrieved

//         // Decode the token to check user details
//         if (jwtToken) {
//           try {
//             const response = await fetch('https://api-utmw-webservice.onrender.com/api/protected/user-details', {
//               method: 'GET',
//               headers: {
//                 'Authorization': `Bearer ${jwtToken}`,
//               },
//             });

//             if (response.ok) {
//               const decodedData = await response.json();
//               console.log('Decoded user data:', decodedData); // Check decoded user data

//               // Check if the decoded email matches admin emails
//               const isAdminEmail = [
//                 process.env.REACT_APP_ADMIN_EMAIL1,
//                 process.env.REACT_APP_ADMIN_EMAIL2,
//                 process.env.REACT_APP_ADMIN_EMAIL3,
//                 process.env.REACT_APP_ADMIN_EMAIL4,
//               ].includes(decodedData.email);

//               console.log('Is admin:', isAdminEmail); // Check if user is admin
//               setIsAdmin(isAdminEmail);
//             } else {
//               console.error('Error fetching user details:', response.statusText);
//             }
//           } catch (error) {
//             console.error('Error decoding JWT token:', error);
//           }
//         } else {
//           console.log('No JWT token found');
//         }
//       } else {
//         setIsLoggedIn(false);
//         setIsAdmin(false);
//       }
//     });

//     return () => unsubscribe();
//   }, []);

//   return (
//     <>
//       <Router>
//         <Navbar isLoggedIn={isLoggedIn} />
//         <div>
//           <Routes>
//             {/* Public Routes */}
//             <Route exact path="/login" element={<Login />} />
//             <Route exact path="/home" element={<Home />} />
//             <Route exact path="/" element={<Home />} />
//             <Route path="/event/:id" element={<EventDetail />} /> {/* Event Detail Route */}
//             <Route path="/ATTENDANCE/:eventId" element={<AttendanceForm />} />
//             {/* Protected Routes */}
//             {isLoggedIn && isAdmin && (
//               <>
//                 <Route exact path="/UploadEvent" element={<UploadEvent />} /> {/* Upload Event Route for Admin */}
//               </>
//             )}
  
//             {/* Add more routes here */}
//           </Routes>
//         </div>
//         <Footer /> {/* Footer component added here */}
//       </Router>
//     </>
//   );
// }

// export default App;


// import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'; // Import Navigate for redirection
// import Home from './components/Home';
// import Navbar from './components/Navbar';
// import "./App.css";
// import { onAuthStateChanged } from "firebase/auth"; 
// import { auth } from './components/firebase'; 
// import Login from './components/Login';
// import UploadEvent from './components/UploadEvent';
// import EventDetail from './components/EventDetail'; 
// import Footer from './components/Footer';
// import AttendanceForm from './components/AttendanceForm';

// const App = () => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [isAdmin, setIsAdmin] = useState(false);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (user) => {
//       if (user) {
//         setIsLoggedIn(true);

//         // Retrieve JWT token from session storage
//         const jwtToken = sessionStorage.getItem('jwtToken');
//         console.log('JWT Token retrieved:', jwtToken); 

//         // Decode the token to check user details
//         if (jwtToken) {
//           try {
//             const response = await fetch('https://api-utmw-webservice.onrender.com/api/protected/user-details', {
//               method: 'GET',
//               headers: {
//                 'Authorization': `Bearer ${jwtToken}`,
//               },
//             });

//             if (response.ok) {
//               const decodedData = await response.json();
//               console.log('Decoded user data:', decodedData); 

//               // Check if the decoded email matches admin emails
//               const isAdminEmail = [
//                 process.env.REACT_APP_ADMIN_EMAIL1,
//                 process.env.REACT_APP_ADMIN_EMAIL2,
//                 process.env.REACT_APP_ADMIN_EMAIL3,
//                 process.env.REACT_APP_ADMIN_EMAIL4,
//               ].includes(decodedData.email);

//               console.log('Is admin:', isAdminEmail); 
//               setIsAdmin(isAdminEmail);
//             } else {
//               console.error('Error fetching user details:', response.statusText);
//             }
//           } catch (error) {
//             console.error('Error decoding JWT token:', error);
//           }
//         } else {
//           console.log('No JWT token found');
//         }
//       } else {
//         setIsLoggedIn(false);
//         setIsAdmin(false);
//       }
//     });

//     return () => unsubscribe();
//   }, []);

//   return (
//     <>
//       <Router>
//         <Navbar isLoggedIn={isLoggedIn} />
//         <div>
//           <Routes>
//             {/* Public Routes */}
//             <Route exact path="/login" element={<Login />} />
//             <Route exact path="/home" element={<Home />} />
//             <Route exact path="/" element={<Home />} />
//             <Route path="/event/:id" element={<EventDetail />} /> 


//             <Route path="/ATTENDANCE/:eventId" element={<AttendanceForm />} />

//             {/* Attendance Form Route (Only for Authenticated Users)
//             <Route 
//               path="/ATTENDANCE/:eventId" 
//               element={isLoggedIn ? <AttendanceForm /> : <Navigate to="/login" />} 
//             /> */}

//             {/* Protected Routes */}
//             {isLoggedIn && isAdmin && (
//               <Route exact path="/UploadEvent" element={<UploadEvent />} />
//             )}
  
//             {/* Add more routes here */}
//           </Routes>
//         </div>
//         <Footer /> {/* Footer component added here */}
//       </Router>
//     </>
//   );
// }

// export default App;







// import React, { useState, useEffect } from 'react'; 
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Removed useNavigate from import
// import Home from './components/Home';
// import Navbar from './components/Navbar';
// import "./App.css";
// import { onAuthStateChanged } from "firebase/auth"; 
// import { auth } from './components/firebase'; 
// import Login from './components/Login';
// import UploadEvent from './components/UploadEvent';
// import EventDetail from './components/EventDetail'; 
// import Footer from './components/Footer';
// import AttendanceForm from './components/AttendanceForm';
// const App = () => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [isAdmin, setIsAdmin] = useState(false); // State to check if the user is an admin
//   const [loading, setLoading] = useState(true);
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (user) => {
//       if (user) {
//         setIsLoggedIn(true);
//         const jwtToken = sessionStorage.getItem('jwtToken');
//         if (jwtToken) {
//           try {
//             const response = await fetch('https://api-utmw-webservice.onrender.com/api/protected/user-details', {
//               method: 'GET',
//               headers: {
//                 'Authorization': `Bearer ${jwtToken}`,
//               },
//             });
//             if (response.ok) {
//               const decodedData = await response.json();
//               const isAdminEmail = [
//                 process.env.REACT_APP_ADMIN_EMAIL1,
//                 process.env.REACT_APP_ADMIN_EMAIL2,
//                 process.env.REACT_APP_ADMIN_EMAIL3,
//                 process.env.REACT_APP_ADMIN_EMAIL4,
//               ].includes(decodedData.email);
//               setIsAdmin(isAdminEmail);
//             }
//           } catch (error) {
//             console.error('Error decoding JWT token:', error);
//           }
//         }
//       } else {
//         setIsLoggedIn(false);
//         setIsAdmin(false);
//       }
//       setLoading(false); // Set loading to false once the check is done
//     });
  
//     return () => unsubscribe();
//   }, []);

//   return (
//     <>
//       {loading ? (
//         <div>Loading...</div> // Show a loader while checking authentication
//       ) : (
//         <Router>
//           <Navbar isLoggedIn={isLoggedIn} />
//           <div>
//             <Routes>
//               <Route exact path="/login" element={<Login />} />
//               <Route exact path="/home" element={<Home />} />
//               <Route exact path="/" element={<Home />} />
//               <Route path="/event/:id" element={<EventDetail />} />
//               <Route path="/ATTENDANCE/:eventId" element={<AttendanceForm />} />
//               {isLoggedIn && isAdmin && <Route exact path="/UploadEvent" element={<UploadEvent />} />}
//             </Routes>
//           </div>
//           <Footer />
//         </Router>
//       )}
//     </>
//   );
  
// }

// export default App;




// import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// import Home from './components/Home';
// import Navbar from './components/Navbar';
// import "./App.css";
// import { onAuthStateChanged } from "firebase/auth";
// import { auth } from './components/firebase';
// import Login from './components/Login';
// import UploadEvent from './components/UploadEvent';
// import EventDetail from './components/EventDetail';
// import Footer from './components/Footer';
// import AttendanceForm from './components/AttendanceForm';

// const App = () => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [isAdmin, setIsAdmin] = useState(false);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (user) => {
//       if (user) {
//         setIsLoggedIn(true);
//         const jwtToken = sessionStorage.getItem('jwtToken');
        
//         if (jwtToken) {
//           try {
//             const response = await fetch('https://user-management-api-latest.onrender.com/api/protected/user-details', {
//               method: 'GET',
//               headers: {
//                 'Authorization': `Bearer ${jwtToken}`,
//               },
//             });
            
//             if (response.ok) {
//               const decodedData = await response.json();
//               const isAdminEmail = [
//                 process.env.REACT_APP_ADMIN_EMAIL1,
//                 process.env.REACT_APP_ADMIN_EMAIL2,
//                 process.env.REACT_APP_ADMIN_EMAIL3,
//                 process.env.REACT_APP_ADMIN_EMAIL4,
//               ].includes(decodedData.email);

//               setIsAdmin(isAdminEmail);
//             }
//           } catch (error) {
//             console.error('Error decoding JWT token:', error);
//           }
//         }
//       } else {
//         setIsLoggedIn(false);
//         setIsAdmin(false);
//       }
      
//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, []);

//   if (loading) return <div>Loading...</div>;

//   return (
//     <Router>
//       <Navbar isLoggedIn={isLoggedIn} />
//       <div>
//         <Routes>
//           <Route exact path="/login" element={<Login />} />
//           <Route exact path="/home" element={<Home />} />
//           <Route exact path="/" element={<Home />} />
//           <Route path="/event/:id" element={<EventDetail />} />
//           <Route path="/ATTENDANCE/:eventId" element={<AttendanceForm />} />
//           {isLoggedIn && isAdmin && <Route exact path="/UploadEvent" element={<UploadEvent />} />}
//           {/* Redirect to /UploadEvent if the user is an admin */}
//           {/* {isLoggedIn && isAdmin && <Route path="*" element={<Navigate to="/UploadEvent" />} />} */}
//         </Routes>
//       </div>
//       <Footer />
//     </Router>
//   );
// }

// export default App;



// import React, { useState, useEffect } from 'react'; // Import useState and useEffect
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Home from './components/Home';
// import Navbar from './components/Navbar';
// import "./App.css";
// // import 'react-toastify/dist/ReactToastify.css';
// import { onAuthStateChanged } from "firebase/auth"; // Import onAuthStateChanged
// import { auth } from './components/firebase'; // Import auth from firebase.js (assuming firebase.js is in the same directory)
// import Login from './components/Login';
// import UploadEvent from './components/UploadEvent';
// import EventDetail from './components/EventDetail'; // Import EventDetail component
// import Footer from './components/Footer';
// import AttendanceForm from './components/AttendanceForm';

// const App = () => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setIsLoggedIn(true);
//       } else {
//         setIsLoggedIn(false);
//       }
//     });

//     return () => unsubscribe();
//   }, []);

//   return (
//     <>
//       <Router>
//         <Navbar isLoggedIn={isLoggedIn} />
//         <div>
//           <Routes>
//             {/* Public Routes */}
//             <Route exact path="/login" element={<Login />} />
//             <Route exact path="/home" element={<Home />} />
//             <Route exact path="/" element={<Home />} />
//             <Route path="/event/:id" element={<EventDetail />} /> {/* Event Detail Route */}
//             <Route path="/ATTENDANCE/:eventId" element={<AttendanceForm />} />
//             {/* Protected Routes */}
//             {isLoggedIn && (
//               <>
//                 <Route exact path="/UploadEvent" element={<UploadEvent />} /> {/* Upload Event Route */}
//               </>
//             )}
  
//             {/* Add more routes here */}
//           </Routes>
//         </div>
//         <Footer /> {/* Footer component added here */}
//       </Router>
//     </>
//   );
  
// }

// export default App;


import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Navbar from './components/Navbar';
import Login from './components/Login';
import UploadEvent from './components/UploadEvent';
import EventDetail from './components/EventDetail';
import Footer from './components/Footer';
import AttendanceForm from './components/AttendanceForm'; // Import AttendanceForm component
import { onAuthStateChanged } from "firebase/auth";
import { auth } from './components/firebase'; // Import Firebase auth
import './App.css';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user); // Set login state based on auth status
    });
    return () => unsubscribe();
  }, []);

  return (
    <>
      <Router>
        <Navbar isLoggedIn={isLoggedIn} />
        <div>
          <Routes>
            {/* Public Routes */}
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/home" element={<Home />} />
            <Route exact path="/" element={<Home />} />
            <Route path="/event/:id" element={<EventDetail />} /> {/* Event Detail Route */}
            
            {/* Attendance Form Route */}
            <Route path="/attendance/:eventId" element={<AttendanceForm />} /> {/* Add AttendanceForm Route */}

            {/* Protected Routes */}
            {isLoggedIn && (
              <>
                <Route exact path="/UploadEvent" element={<UploadEvent />} /> {/* Upload Event Route */}
              </>
            )}
          </Routes>
        </div>
        <Footer /> {/* Footer component */}
      </Router>
    </>
  );
};

export default App;

